{
  "title": "Deposits",
  "searchPlaceholder": "Deposit number, reference, customer name or phone",
  "exportPdf": "Export PDF",
  "exportFile": "deposits",
  "columns": {
    "depositedAt": "Deposit date",
    "recipient": "Recipient"
  },
  "filters": {
    "any": "All",
    "allStates": "All except cancelled and drafts",
    "dateType": "Date type",
    "depositDate": "Deposit date",
    "deliveryDate": "Delivery date"
  },
  "sortBy": "Sort by {{column}}",
  "rowActions": "Actions for deposit {{number}}"
}
